import { Box, Modal, IconButton } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';

import { faAt, faLock } from '@fortawesome/pro-light-svg-icons';
import { Button, Divider, InputAdornment, TextField } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import AuthenticationActionCreator from '../../actions/AuthenticationActionCreator';
import isValidEmail from '../../core/typeguards/isValidEmail';
import { FORGOT_PASSWORD_PATH, REGISTER_USER } from '../../models/Paths';
import { IRequestDataFailedAction } from '../../models/state';
import { IUser } from '../../models/user/IUser';
import { getAuthenticationError } from '../../selectors/AuthenticationSelectors';
import useTranslation from '../../services/i18n/core/useTranslation';
import NotificationActionCreator from '../../services/Notifications/actions/NotificationActionCreator';
import Checkbox from '../Checkbox';
import Icon from '../Icon';
// import Modal from '../Modal';
import addMinutes from 'date-fns/addMinutes';
import CookieStorageAPI from '../../core/storage/CookieStorageAPI';
import FBLoginButton from 'services/Facebook/FBLoginButton';
import useLoginHandler from '../../services/Facebook/useLoginHandler';
import { Typography } from '@mui/material';
import GoogleLoginButton from 'services/Google/GoogleLoginButton';
import useGoogleLoginHandler from 'services/Google/useGoogleLoginHandler';
import Config from 'config';
import { alpha, useTheme } from '@mui/material/styles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
const usnLsKey = btoa('usn');
const passwdLsKey = btoa('pswd');

export interface ISignInComponentProps { }
const LoginModal = ({ open, onClose }: { open: boolean; onClose: () => void }) => {
    const [showPassword, setShowPassword] = useState(false);
    const theme = useTheme();
    const brandColor = Config.GLOBAL_PRIMARY_COLOR;
    const brandSoft = alpha(brandColor, 0.1);
    const brandBorder = alpha(brandColor, 0.18);
    const brandStrong = alpha(brandColor, 0.92);
    const textMuted = alpha(theme.palette.text.primary, 0.65);
    const dividerColor = alpha(theme.palette.text.primary, 0.08);

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const { email: lsem, password: lspasswd } = retrieveFromLS();
    const [email, setEmail] = useState<string>(lsem);
    const [password, setPassword] = useState<string>(lspasswd);
    const [isLoading, setLoading] = useState<boolean>(false);
    const [savePassword, setsavePassword] = useState<boolean>(true);
    const [errorHelperText, setErrorHelperText] = useState('');

    const error = useSelector(getAuthenticationError);

    const { EMPTY_EMAIL_INPUT, EMPTY_PASSWORD_INPUT, LOGIN_BUTTON } = useTranslation();

    const dispatch = useDispatch();
    const handleFBLogin = useLoginHandler();
    const history = useHistory();

    useEffect(() => {
        void (async () => {
            const searchParams = new URLSearchParams(history.location.search);
            try {
                const ext = searchParams.get('ext');
                if (ext) {
                    const json = JSON.parse(atob(ext)) as [IUser];
                    await dispatch(AuthenticationActionCreator.transientLogin(json));
                }

                const redirect = searchParams.get('redirect');
                if (redirect) {
                    history.replace(redirect);
                }
            } catch {
                //
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (error?.Note === 'Error Password') {
            setErrorHelperText('Email oder Passwort falsch!');
        }
    }, [error]);

    async function handleLogin() {
        if (email.trim() === '' || password.trim() === '') {
            // check if the email is faulty
            //Alert.alert('Anmeldung fehlgeschlagen!', email === '' ? EMPTY_EMAIL_INPUT : EMPTY_PASSWORD_INPUT);
            dispatch(
                NotificationActionCreator.enqueueSnackbar({
                    key: String(new Date().getTime() + Math.random()),
                    message: email === '' ? EMPTY_EMAIL_INPUT : EMPTY_PASSWORD_INPUT,
                    options: { variant: 'error' },
                })
            );
        } else if (isValidEmail(email)) {
            // if everything is ok we can proceed by submitting the credentials
            // check if login was successful if not, display error message
            setLoading(true);
            CookieStorageAPI.setItem('loggedIN', 'true', { expires: addMinutes(new Date(), 5) });
            (await dispatch(AuthenticationActionCreator.loginUser({ email, password }))) as IRequestDataFailedAction;
            setLoading(false);
            const profileId = history.location.pathname.includes('profile') ? history.location.pathname.replace('profile', 'stranger-profile') : '/';
            history.push(profileId);
            if (savePassword) {
                // WARN: This beavior does counter the dsgvo law, since we do save user specific data, without his consense.
                // Furthermore we do create an additional attack layer to retrieve the users information via localstorage exposure
                persistToLS(email, password);
            } else {
                removeFromLs();
            }
        } else {
            //Alert.alert('Anmeldung fehlgeschlagen!', NOT_VALID_EMAIL);
            // dispatch(
            //     NotificationActionCreator.enqueueSnackbar({
            //         key: String(new Date().getTime() + Math.random()),
            //         message: NOT_VALID_EMAIL,
            //         options: { variant: 'error' },
            //     })
            // );
            setPassword('');
        }
    }

    const handleChangeSavePassword = useCallback((e: React.ChangeEvent<HTMLElement>, value: boolean) => setsavePassword(value), []);

    const handleForgotPassword = useCallback(() => {
        history.push(FORGOT_PASSWORD_PATH);
    }, [history]);

    const handleOpenRegister = () => {
        history.push(REGISTER_USER);
    };

    const handleEnter = async (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (errorHelperText) {
            setErrorHelperText('');
            dispatch(AuthenticationActionCreator.cancelAuthentication());
        }
        if (e.key === 'Enter' && !e.ctrlKey && !e.shiftKey) {
            await handleLogin();
        }
    };

    // eslint-disable-next-line
    // const handleFBLogin = useLoginHandler();

    // const handleGoogleLogin = useCallback(async (response: any) => {
    //     try {
    //         setLoading(true);
    //         // Implement your Google login logic here similar to Facebook login
    //         // You might want to dispatch an action like:
    //         // await dispatch(AuthenticationActionCreator.loginGoogleUser({ googleToken: response.credential }));
    //     } finally {
    //         setLoading(false);
    //     }
    // }, []);


    const handleGoogleLogin = useGoogleLoginHandler();

    return (
        <Modal
            open={open}
            onClose={onClose}
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: alpha(theme.palette.common.black, 0.5),
                        backdropFilter: 'blur(8px)',
                    },
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 'min(440px, calc(100vw - 24px))',
                    maxHeight: 'calc(100vh - 24px)',
                    overflowY: 'auto',
                    p: { xs: 2, sm: 3 },
                    borderRadius: '28px',
                    border: `1px solid ${brandBorder}`,
                    color: theme.palette.text.primary,
                    background: `linear-gradient(180deg, ${alpha(theme.palette.background.paper, 0.98)} 0%, ${alpha(theme.palette.background.paper, 0.94)} 100%)`,
                    boxShadow: `0 32px 80px ${alpha(theme.palette.common.black, 0.24)}`,
                }}
            >
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        top: 14,
                        right: 14,
                        border: `1px solid ${brandBorder}`,
                        backgroundColor: alpha(theme.palette.background.paper, 0.75),
                    }}
                >
                    <CloseRoundedIcon fontSize="small" />
                </IconButton>

                <Box
                    sx={{
                        mb: 3,
                        p: 2.25,
                        borderRadius: '22px',
                        background: `linear-gradient(135deg, ${brandSoft} 0%, ${alpha(brandColor, 0.04)} 100%)`,
                        border: `1px solid ${brandBorder}`,
                    }}
                >
                    <Typography sx={{ mb: 0.75, fontSize: '1.5rem', fontWeight: 800, lineHeight: 1.1 }}>{LOGIN_BUTTON}</Typography>
                    <Typography sx={{ color: textMuted, fontSize: '0.98rem' }}>
                        Melde dich mit deiner E-Mail-Adresse an und setze deine Unterhaltung direkt fort.
                    </Typography>
                </Box>

                <div title="Jetzt einloggen" className="text-align-center spacing triple padding bottom">
                    <form id="login-form" autoComplete="login" onSubmit={(e) => e.preventDefault()} className="flex column no-grow">
                        <TextField
                            id="email"
                            sx={{ mb: 2 }}
                            fullWidth
                            label="Deine E-Mail Adresse"
                            autoComplete="email"
                            value={email}
                            onChange={(e) => setEmail(e.currentTarget.value)}
                            onKeyPress={handleEnter}
                            error={Boolean(errorHelperText)}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <Icon icon={faAt} style={{ color: brandColor }} />
                                    </InputAdornment>
                                ),
                                style: {
                                    borderRadius: '16px',
                                },
                            }}
                        />
                        <TextField
                            sx={{ mb: 2 }}
                            fullWidth
                            id="password"
                            type={showPassword ? 'text' : 'password'}
                            label="Dein Passwort"
                            autoComplete="current-password"
                            onKeyPress={handleEnter}
                            value={password}
                            onChange={(e) => setPassword(e.currentTarget.value)}
                            error={Boolean(errorHelperText)}
                            helperText={errorHelperText}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end" sx={{ gap: 0.5 }}>
                                        <Icon icon={faLock} style={{ color: brandColor }} />
                                        <IconButton edge="end" onClick={togglePasswordVisibility} tabIndex={-1}>
                                            {showPassword ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                style: {
                                    borderRadius: '16px',
                                },
                            }}
                        />

                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1.5, mb: 1.5, flexWrap: 'wrap' }}>
                            <Checkbox
                                color="primary"
                                label="Passwort merken?"
                                labelPlacement="end"
                                onChange={handleChangeSavePassword}
                                checked={savePassword}
                                className="spacing margin left"
                            />

                            <Button
                                variant="text"
                                color="primary"
                                onClick={handleForgotPassword}
                                sx={{ px: 0, minWidth: 'auto', fontWeight: 700 }}
                            >
                                Passwort vergessen?
                            </Button>
                        </Box>

                        <Button
                            fullWidth
                            variant="contained"
                            onClick={handleLogin}
                            className="spacing double margin top bottom"
                            type="submit"
                            sx={{
                                minHeight: 52,
                                borderRadius: '16px',
                                fontWeight: 800,
                                textTransform: 'none',
                                background: `linear-gradient(135deg, ${brandStrong} 0%, ${brandColor} 100%)`,
                                boxShadow: `0 18px 36px ${alpha(brandColor, 0.28)}`,
                            }}
                        >
                            Einloggen
                        </Button>
                        {Config.GLOBAL_SITE_DOMAIN === 'voluu.de' && (
                            <>
                                <Box sx={{ display: 'grid', gap: 1.25, mt: 1.5 }}>
                                    <FBLoginButton setLoading={setLoading} onLoginFinished={handleFBLogin} />
                                    <GoogleLoginButton setLoading={setLoading} onLoginFinished={handleGoogleLogin} />
                                </Box>
                                {/*<div style={{ marginBottom: 5 }}>
                                <AppleLoginButton setLoading={setLoading} onLoginFinished={handleAppleLogin} />
                            </div>*/}
                            </>
                        )}
                    </form>

                    {isLoading && (
                        <Typography sx={{ mt: 2, color: textMuted, fontSize: '0.95rem', textAlign: 'center' }}>
                            Anmeldung wird vorbereitet...
                        </Typography>
                    )}

                    <Divider sx={{ my: 2.5, borderColor: dividerColor }} />
                    {/* <div style={{ marginTop: 24, marginBottom: 24 }}>
                <FBLoginButton setLoading={setLoading} onLoginFinished={handleFBLogin} />
            </div>
            {process.env.NODE_ENV === 'development' && (
                <div style={{ marginTop: 24, marginBottom: 24 }}>
                    <AppleLoginButton setLoading={setLoading} onLoginFinished={handleAppleLogin} />
                </div>
            )} */}
                    <Typography sx={{ mb: 0.75, fontWeight: 700 }}>Noch nicht dabei?</Typography>
                    <Typography sx={{ mb: 1.5, color: textMuted, fontSize: '0.95rem' }}>
                        Erstelle dein Profil in wenigen Schritten.
                    </Typography>
                    <Button onClick={handleOpenRegister} variant="text" color="primary" sx={{ fontWeight: 800 }}>
                        Jetzt registrieren!
                    </Button>
                </div>
            </Box>
        </Modal>
    );
};

export default LoginModal;

function persistToLS(email: string, password: string) {
    localStorage.setItem(usnLsKey, btoa(email));
    localStorage.setItem(passwdLsKey, btoa(password));
}

function removeFromLs() {
    localStorage.removeItem(usnLsKey);
    localStorage.removeItem(passwdLsKey);
}

function retrieveFromLS() {
    const email = localStorage.getItem(usnLsKey) ?? '';
    const password = localStorage.getItem(passwdLsKey) ?? '';

    return {
        email: atob(email),
        password: atob(password),
    };
}
